"use client";

import { useEffect, useRef } from "react";
import { addParamsToURL, isWindowDefined } from "@huub-web/utils";
import { useDebug } from "@huub-web/ui";

type CalendlyPrefill = {
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  location?: string;
  customAnswers?: Record<string, string>;
  guests?: string[];
};

export type CalendlyProps = {
  url: string;
  prefill?: CalendlyPrefill;
  pageSettings?: {
    // TODO: Not working?
    backgroundColor?: string;
    hideEventTypeDetails?: boolean;
    hideLandingPageDetails?: boolean;
    primaryColor?: string;
    textColor?: string;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  utm?: Record<string, any>;
  height?: number;
};

export const Calendly = ({
  url,
  prefill,
  pageSettings = {
    hideEventTypeDetails: true,
    hideLandingPageDetails: true,
  },
  utm,
  height = 630,
}: CalendlyProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const hasInitiatedRef = useRef(false);
  const { log } = useDebug();

  useEffect(() => {
    if (hasInitiatedRef.current || !isWindowDefined()) {
      return;
    }
    hasInitiatedRef.current = true;

    log("red", "Calendly", "Loading script", url);

    const loadScript = () => {
      const existingScript = document.getElementById("calendly-widget-script");
      if (existingScript) {
        return Promise.resolve();
      }

      return new Promise<void>((resolve) => {
        const script = document.createElement("script");
        script.id = "calendly-widget-script";
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        script.onload = () => resolve();
        document.body.appendChild(script);
      });
    };

    loadScript().then(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((window as { Calendly?: any }).Calendly && containerRef.current) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as { Calendly?: any }).Calendly.initInlineWidget({
          url: addParamsToURL(url, {
            hide_event_type_details: "1",
            hide_gdpr_banner: "1",
          }),
          parentElement: containerRef.current,
          prefill,
          pageSettings,
          utm,
          onEventScheduled: () => {
            log("red", "Calendly", "onEventScheduled");
          },
          onEventCancelled: () => {
            log("red", "Calendly", "onEventCancelled");
          },
        });
      }
    });
  }, []);

  return <div ref={containerRef} style={{ minWidth: "320px", height }} />;
};
